import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { finalizarSessao } from '../reducers/autenticacao.reducer';
import { SubContainer } from '../../shared/components/layout_components/sub_container/styles';
import { Container } from '../../shared/components/layout_components/container/styles';

const LogoutPage: React.FC = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    document.title = 'SisIEC - Fazendo logout';

    dispatch(finalizarSessao());
  }, []);

  return (
    <Container>
      <SubContainer flex={4}></SubContainer>
    </Container>
  );
};

export { LogoutPage };
